/** Reconnection delay (spec §7.5): 1 s doubling up to 30 s, ±20 % jitter so a studio's tabs do not reconnect in step. */
export function jitteredDelay(attempt: number, rand: () => number = Math.random): number {
  const base = Math.min(1_000 * 2 ** attempt, 30_000);
  return Math.round(base * (0.8 + 0.4 * rand()));
}
